import { memo, useState } from "react";
import { AutoComplete, Form } from "antd";

const InputAutoComplete = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const avatarNamesToRemove = props.recorddetails.map((item) => item.avatar);
  const filteredFirstSet = props.avatarlist.filter(
    (item) => !avatarNamesToRemove.includes(item.avatar_name)
  );
  const [tagavatarlist, setTagAvatarList] = useState(
    filteredFirstSet.map((data) => data.avatar_name)
  );
  const onFocusInput = () => {
    setDataSource(tagavatarlist);
  };

  // Filter out objects from the first set that have avatar names to remove

  console.log(filteredFirstSet);
  const onNameChange = (value) => {
    const filteredNames = mockFetchNames(value);
    setDataSource(filteredNames);
  };

  const mockFetchNames = (value) => {
    const allNames = tagavatarlist;
    return allNames.filter((name) =>
      name.toLowerCase().includes(value.toLowerCase())
    );
  };

  return (
    <>
      <Form.Item
        {...props.restField}
        name={[props.field.name, "fieldName"]}
        className="mar-0"
      >
        <AutoComplete
          style={{ width: 200 }}
          options={dataSource.map((name) => ({
            value: name,
          }))}
          onSearch={onNameChange}
          onFocus={onFocusInput}
          placeholder="Type here "
          className="aivolvex-tag-input"
        />
      </Form.Item>
    </>
  );
};

export default memo(InputAutoComplete);
